import { Component } from "react";
import RectButton from "../button/RectButton";

import "./style.scss";

class InputFile extends Component {
    render() {
        return (
            <>
                <label className="input-file" htmlFor="upload">
                    <span aria-hidden="true">Please select a file</span>
                    <input id="upload" type="file" name="file" />
                    <RectButton text="SELECT A FILE" />
                </label>
            </>
        )
    }
}

export default InputFile;